import { jsx as i, jsxs as p } from "react/jsx-runtime";
import ge, { useState as g, useEffect as y } from "react";
import { Calendar as Q } from "react-calendar";
import { useForwardedRef as ye } from "@givebutter/react-util";
import { transformDatePickerValues as x, dateToString as k, transformDateTimeValuesDownstream as xe, transformComparativeDates as R, downstreamTzTransform as U, getValidDateFromString as W, upstreamTzTransform as F } from "@givebutter/util";
import { faXmark as Y, faArrowRightLong as ke } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon as M } from "@fortawesome/react-fontawesome";
import { Button as Z } from "../button/Button.js";
import { Root as I, Form as B } from "../input/Input.js";
import { Root as Fe, Trigger as De, Portal as Te, Content as Ve } from "../popover/Popover.js";
import { DateTime as Ae } from "luxon";
import { twMerge as C } from "tailwind-merge";
const ae = ge.forwardRef(
  ({
    open: D,
    onOpenChange: $,
    onChange: d,
    onBlurInput: l,
    value: v,
    selectRange: r,
    popoverProps: te,
    popoverContentProps: re,
    startInputRef: oe,
    endInputRef: ne,
    isTextInput: ie = !0,
    startInputProps: de = {},
    endInputProps: _e = {},
    className: q = "",
    minDate: s,
    maxDate: L,
    clearable: T = !1,
    isError: X,
    ...ce
  }, le) => {
    const {
      onBlur: V,
      onFocus: A,
      ...se
    } = de, {
      onBlur: P,
      onFocus: S,
      ...fe
    } = _e, [f, O] = g(!1), z = T ? void 0 : Ae.now(), me = r ? [z, z] : z, [_, w] = g(
      v ?? me
    ), [G, b] = g(), [H, u] = g(), J = ye(le), E = J.current;
    y(() => {
      v && typeof d < "u" && w(v);
    }, [d, v]), y(() => {
      const e = x(_, !!r);
      e.dateFrom ? b(k(e.dateFrom)) : b(""), e.dateTo ? u(k(e.dateTo)) : u("");
    }, [_, r]), y(() => {
      typeof D < "u" && O(D);
    }, [D]), y(() => {
      E && E.querySelectorAll("button").forEach((o) => {
        o.tabIndex = -1;
      });
    }, [E]);
    const N = (e) => {
      $ ? $(e) : O(e);
    }, K = (e) => {
      f && e.preventDefault(), f || N(!0);
    }, ve = (e, o) => {
      const [t, c] = Array.isArray(o) ? o : [o, o];
      if (r && Array.isArray(e)) {
        const [a, n] = e;
        return [
          a ? F(a, t) : void 0,
          n ? F(n, c) : void 0
        ];
      }
      if (e) {
        if (Array.isArray(e)) {
          const [a] = e;
          return a ? F(a, t) : void 0;
        }
        return F(e, t);
      }
    }, j = (e, o) => {
      let t;
      w((c) => (t = ve(e, c), t)), d == null || d(t, o);
    }, we = (e) => {
      f || N(!0), A == null || A(e);
    }, be = (e) => {
      f || N(!0), S == null || S(e);
    }, ue = (e) => {
      const o = e.target.value, t = x(_, !!r), c = t.dateTo ?? void 0, a = W(o);
      if (a.isValid && (!s || a >= s)) {
        let n;
        if (r) {
          const pe = c && a > c ? a : t.dateTo;
          n = [a, pe];
        } else
          n = a;
        d ? d(n, e) : w(n), l == null || l(e, n), V == null || V(e);
        return;
      }
      t.dateFrom && b(k(t.dateFrom));
    }, he = (e) => {
      const o = e.target.value, t = x(_, !!r), c = t.dateFrom ?? void 0, a = W(o);
      if (a.isValid && c && a > c && (!s || a >= s)) {
        const n = r ? [t.dateFrom, a] : a;
        d ? d(n, e) : w(n), l == null || l(e, n), P == null || P(e);
        return;
      }
      t.dateTo && u(k(t.dateTo));
    }, m = xe(
      x(_, !!r)
    ), h = {
      inputRef: J,
      selectRange: r,
      value: r && m.dateFrom && m.dateTo ? [m.dateFrom, m.dateTo] : m.dateFrom,
      onChange: j,
      minDate: s ? R(s) : void 0,
      maxDate: L ? R(L) : void 0,
      ...ce
    };
    return ie ? /* @__PURE__ */ p(Fe, { ...te, open: f, onOpenChange: O, children: [
      /* @__PURE__ */ i(De, { onClick: (e) => e.preventDefault(), asChild: !0, children: /* @__PURE__ */ p(
        "div",
        {
          role: "combobox",
          className: C(q, "flex items-center gap-2"),
          children: [
            /* @__PURE__ */ p(I, { isError: X, children: [
              /* @__PURE__ */ i(
                B,
                {
                  ref: oe,
                  onClick: K,
                  onChange: (e) => b(e.target.value),
                  onBlur: ue,
                  onFocus: we,
                  value: G,
                  placeholder: "Start",
                  ...se
                }
              ),
              T && G && /* @__PURE__ */ i(
                Z,
                {
                  "aria-label": "Clear start date",
                  variant: "none",
                  color: "neutral",
                  onClick: (e) => {
                    j(
                      r ? [
                        void 0,
                        _[1] ? U(_[1]) : void 0
                      ] : void 0,
                      e
                    );
                  },
                  children: /* @__PURE__ */ i(M, { size: "xs", icon: Y })
                }
              )
            ] }),
            r && /* @__PURE__ */ i(M, { className: "text-xs", icon: ke }),
            r && /* @__PURE__ */ p(I, { isError: X, children: [
              /* @__PURE__ */ i(
                B,
                {
                  ref: ne,
                  onClick: K,
                  onChange: (e) => u(e.target.value),
                  onBlur: he,
                  onFocus: be,
                  value: H,
                  placeholder: "End",
                  ...fe
                }
              ),
              T && H && /* @__PURE__ */ i(
                Z,
                {
                  "aria-label": "Clear end date",
                  variant: "none",
                  color: "neutral",
                  onClick: (e) => {
                    j(
                      [
                        _[0] ? U(_[0]) : void 0,
                        void 0
                      ],
                      e
                    );
                  },
                  children: /* @__PURE__ */ i(M, { size: "xs", icon: Y })
                }
              )
            ] })
          ]
        }
      ) }),
      /* @__PURE__ */ i(Te, { children: /* @__PURE__ */ i(
        Ve,
        {
          onOpenAutoFocus: (e) => e.preventDefault(),
          onCloseAutoFocus: (e) => e.preventDefault(),
          align: "start",
          sideOffset: 6,
          ...re,
          children: /* @__PURE__ */ i(
            Q,
            {
              ...h,
              className: C(
                ee,
                h.showDoubleView ? "show-double-view" : "",
                "w-80 p-6"
              )
            }
          )
        }
      ) })
    ] }) : /* @__PURE__ */ i(
      Q,
      {
        ...h,
        className: C(
          q,
          ee,
          h.showDoubleView ? "show-double-view" : "",
          "w-80 p-6"
        )
      }
    );
  }
);
ae.displayName = "DatePicker";
const ee = String.raw`[&_react-calendar\_\_month-view\_\_days]:!grid
  [&_react-calendar\_\_month-view\_\_days]:grid-cols-[repeat(7,_1fr)]
  [&_.react-calendar\_\_month-view\_\_weekdays]:mb-1
  [&_.react-calendar\_\_month-view\_\_weekdays]:!grid
  [&_.react-calendar\_\_month-view\_\_weekdays]:grid-cols-[repeat(7,_1fr)]
  [&_.react-calendar\_\_tile]:size-8
  [&_.react-calendar\_\_tile]:cursor-pointer
  [&_.react-calendar\_\_tile]:rounded-lg
  [&_.react-calendar\_\_tile]:border-none
  [&_.react-calendar\_\_tile]:bg-white
  [&_.react-calendar\_\_tile]:p-0
  [&_.react-calendar\_\_tile]:text-sm
  [&_.react-calendar\_\_tile]:font-medium
  [&_.react-calendar\_\_tile]:flex-none
  [&_.react-calendar\_\_tile:hover]:!bg-gray-200
  [&_.react-calendar\_\_tile:hover]:text-inherit
  [&_[disabled]]:cursor-not-allowed
  [&_[disabled]]:!text-gray-300
  [&_[disabled]:hover]:!bg-transparent
  [&_[disabled]:hover]:!text-gray-300
  [&_.react-calendar\_\_tile--active]:!bg-brand-cobalt-dark
  [&_.react-calendar\_\_tile--active:hover]:!bg-brand-cobalt-dark
  [&_.react-calendar\_\_tile--active]:!text-white
  [&_.react-calendar\_\_tile--active:hover]:text-white
  [&_.react-calendar\_\_tile--hasActive]:!bg-brand-cobalt-dark
  [&_.react-calendar\_\_tile--hasActive]:text-white
  [&_.react-calendar\_\_month-view\_\_weekdays\_\_weekday]:flex-none
  [&_.react-calendar\_\_month-view\_\_weekdays\_\_weekday]:text-center
  [&_.react-calendar\_\_month-view\_\_weekdays\_\_weekday]:text-gray-500
  [&_.react-calendar\_\_month-view\_\_weekdays\_\_weekday>abbr]:cursor-default
  [&_.react-calendar\_\_month-view\_\_weekdays\_\_weekday>abbr]:text-[13px]
  [&_.react-calendar\_\_month-view\_\_weekdays\_\_weekday>abbr]:font-normal
  [&_.react-calendar\_\_month-view\_\_weekdays\_\_weekday>abbr]:no-underline
  [&_.react-calendar\_\_tile--range:not(.react-calendar\_\_tile--rangeStart,.react-calendar\_\_tile--rangeEnd)]:!text-brand-cobalt-dark
  [&_.react-calendar\_\_tile--range:not(.react-calendar\_\_tile--rangeStart,.react-calendar\_\_tile--rangeEnd)]:!bg-indigo-50
  [&>.react-calendar\_\_navigation]:mb-4
  [&>.react-calendar\_\_navigation]:flex
  [&>.react-calendar\_\_navigation]:justify-between
  [&>.react-calendar\_\_navigation>button]:cursor-pointer
  [&>.react-calendar\_\_navigation>button]:p-1
  [&>.react-calendar\_\_navigation>button]:border-none
  [&>.react-calendar\_\_navigation>button]:bg-white
  [&>.react-calendar\_\_navigation>button]:px-2
  [&>.react-calendar\_\_navigation>button]:font-semibold
  [&>.react-calendar\_\_navigation>button:hover]:rounded-lg
  [&>.react-calendar\_\_navigation>button:hover]:bg-gray-200
  [&_.react-calendar\_\_month-view\_\_days\_\_day--neighboringMonth]:text-gray-500
  [&_.react-calendar\_\_month-view\_\_days\_\_day--neighboringMonth>abbr]:font-normal
  [&.show-double-view]:w-[626px]
  [&.show-double-view_.react-calendar\_\_viewContainer]:!flex
  [&.show-double-view_.react-calendar\_\_viewContainer]:justify-between
  [&.show-double-view_.react-calendar\_\_month-view\_\_days\_\_day--neighboringMonth]:invisible`, Xe = ae;
export {
  ae as DatePicker,
  Xe as Root
};
